import { ReactNode } from "react";
import {
  AlignItems,
  Avatar,
  Box,
  FontWeight,
  Glyph,
  P,
  Space,
  ColorPreset,
  Color,
  AvatarSize,
  TypePreset,
} from "@gocardless/flux-react";

interface MarketingBenefitProps {
  benefit: ReactNode;
  iconGlyph: Glyph;
  iconSize?: string;
}

export const MarketingBenefit = ({
  benefit,
  iconGlyph,
}: MarketingBenefitProps) => (
  <Box layout="flex" flexDirection="row" alignItems={AlignItems.Center}>
    <Box width="48px">
      <Avatar
        size={AvatarSize.Md}
        color={ColorPreset.BackgroundDark_04}
        icon={iconGlyph}
        bg={ColorPreset.IconOnDark_00}
      />
    </Box>
    <Box gutterH={0.25}>
      <Space h={0.25} />
    </Box>
    <P
      color={Color.Greystone_50}
      preset={TypePreset.Body_02}
      size={2}
      weight={FontWeight.SemiBold}
    >
      {benefit}
    </P>
  </Box>
);
